export default "__VITE_ASSET__DrVwFUgK__"